module.exports = __webpack_public_path__ + "static/game-01d714bc510a7e150b3e69a8f96426b6.png";